import { useLocation } from "react-router-dom";

export default function useQueryString() {
  const { search } = useLocation();

  const query = new URLSearchParams(search);

  return { query };
}
